
import makerjs from "makerjs";
function B42(model,zoom,Param,fixedParam){
  //w,h,w1,w2
  console.log("Param==",Param[0].param);
  console.log("Param==",Param);
    var plate=model.plate,markers=model.markers,myZoom=zoom*1,
    B = Param[0].param,
    // L = Param[1].param,R = Param[2].param,T = Param[3].param,S1 = Param[4].param, 
      //  plate = model.plate, markers = model.markers,
       markShift = fixedParam.markShift*1, markShiftTwo = fixedParam.markShiftTwo*1,
       markShiftThree = fixedParam.markShiftThree*1, markShiftFour = fixedParam.markShiftFour*1, markHolesOneD = fixedParam.markHolesOneD*1,
       b = B * 1 * myZoom,       
       h = b,
       w = b,
       r=b/2,
       x=r,y=r,glassH = h, glassW = w;
   if (b !== 0) {
       var TxtB ="B="+ B;
   } 
   var drawAbnormalShapeB42 = {
       paths: {
        "UpLine": new makerjs.paths.Arc([r, r], r, 180,0),
        "DnLine": new makerjs.paths.Arc([r, r], r, 0,180),
       }
   };
   var drawAbnormalShapeB42MarkB = {
       paths: {
        "bottomLine": new makerjs.paths.Line([0, 0-markShift], [b, 0-markShift]),        
        "RightShortUpline": new makerjs.paths.Line([0, -markShift], [0, markShift]),
        "RightShortDnline": new makerjs.paths.Line([b, -markShift], [b, markShift]),
       }  
   };
   makerjs.model.addCaption(drawAbnormalShapeB42MarkB, TxtB,  [0,0-2*markShift], [b, 0-2*markShift]);//长度文字
   
  plate={
    models: {
      drawAbnormalShapeB42: drawAbnormalShapeB42,
      }
    };
    markers={
      models: {
        drawAbnormalShapeB42: drawAbnormalShapeB42,
        drawAbnormalShapeB42MarkB:drawAbnormalShapeB42MarkB,
        }
      };
    
   /*****************************************************************************/
   //return { plate, markers, glassW, glassH }
 
    return{w,h,plate, markers}  
};


export default B42;